/** @jsx jsx */
import { jsx } from "@emotion/core"
import {
  PlanIndicator as BasePlanIndicator,
  PlanIndicatorPlanType as BasePlanIndicatorPlanType,
} from "gatsby-interface"
import { SubscriptionStatus } from "@modules/graphql/types"
import { organizationPlan as organizationPlanText } from "@modules/locales/default.js"
import { interpolateMessage } from "@modules/locales"

const planTypeLabels: Record<PlanIndicatorPlanType, string> = {
  FREE: `Free`,
  INDIVIDUAL: `Individual`,
  TEAM: `Team`,
  ENTERPRISE: `Enterprise`,
  PROFESSIONAL: `Professional`,
  BUSINESS: `Business`,
}

export type PlanIndicatorPlanType = BasePlanIndicatorPlanType

export type PlanIndicatorProps = {
  planType: BasePlanIndicatorPlanType
  status?: SubscriptionStatus
}

export function PlanIndicator({ planType, status }: PlanIndicatorProps) {
  const isTrialling = status === SubscriptionStatus.Trialing
  const planLabel = planTypeLabels[planType]
  const finalLabel = isTrialling
    ? interpolateMessage<"planName">(
        organizationPlanText.labels.triallingPlan,
        { planName: planLabel }
      )
    : planLabel

  return (
    <BasePlanIndicator
      planType={planType}
      aria-label={interpolateMessage<"planName">(
        organizationPlanText.labels.currentPlanName,
        { planName: finalLabel }
      )}
      isTrialling={isTrialling}
    >
      {finalLabel}
    </BasePlanIndicator>
  )
}
